import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function ProtectedRouteAdmin() {
  const token = window.localStorage.getItem("access_token");
  const flag = window.localStorage.getItem("flag");
  let adminLoggedIn = false;

  if (token && flag === "admin") {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      adminLoggedIn = decodedToken.expires > currentTime; // Use decodedToken.exp for expiration check

      if (!adminLoggedIn) {
        window.localStorage.removeItem("access_token");
        window.localStorage.removeItem("flag");
        window.location.reload(); // Reload the page to trigger state updates
      }
    } catch (error) {
      console.error("Failed to decode token", error);
      adminLoggedIn = false;
    }
  }

  return adminLoggedIn ? <Outlet /> : <Navigate to="/adminlogin" />;
}

export default ProtectedRouteAdmin;
